import { IDENTIFIER } from "./constants";

export const getDataFromSource = (
  obj,
  path,
  defaultValue,
) => {
  const keys = Array.isArray(path) ? path : path.trim().split('.');

  let result = obj;

  for (const key of keys) {
    const parsedKey = !isNaN(Number(key)) ? Number(key) : key;

    if (result && typeof result === 'object' && parsedKey in result) {
      result = result[parsedKey];
    } else {
      return defaultValue;
    }
  }

  return result;
};

export const isObjectNotArray = (value) => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export const getValueByPath = (obj, path) =>  {
  return path.split('.').reduce((acc, key) => {
    if (Array.isArray(acc) || /^\d+$/.test(key)) {
      key = Number(key);
    }
    return acc?.[key];
  }, obj);
}

export const fetchDefaultValueForField = (type) => {
  switch (type) {
    case IDENTIFIER.CHECKBOX:
      return null;
    case IDENTIFIER.MULTISELECT:
      return [];
    case IDENTIFIER.INPUTNUMBER:
      return null;
    default:
      return '';
  }
};

export const isNumber = (str) => !isNaN(str) && !isNaN(parseFloat(str));